"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectStatusFilter = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const selectbutton_1 = require("primereact/selectbutton");
const SelectStatusFilter_module_scss_1 = __importDefault(require("./SelectStatusFilter.module.scss"));
const useIsMobile_1 = require("../../hooks/mobile/useIsMobile");
const button_1 = require("primereact/button");
const fi_1 = require("react-icons/fi");
const tfi_1 = require("react-icons/tfi");
const tooltip_1 = require("primereact/tooltip");
const SelectStatusFilter = ({ items = [], onChange, value = '', mode = 'generic', showIconsInDesktop = false, }) => {
    const isMobile = (0, useIsMobile_1.useIsMobile)();
    const [open, setOpen] = (0, react_1.useState)(false);
    const legacyItems = [
        {
            name: 'Online',
            value: 'true',
            icon: (0, jsx_runtime_1.jsx)(tfi_1.TfiPlug, { size: 34 }),
            badgeIcon: (0, jsx_runtime_1.jsx)(fi_1.FiCheckCircle, { className: "text-green-500", size: 25 }),
            selectedClasses: 'bg-green-100 border-green-500 text-green-700',
        },
        {
            name: 'Offline',
            value: 'false',
            icon: (0, jsx_runtime_1.jsx)(tfi_1.TfiPlug, { size: 34 }),
            badgeIcon: (0, jsx_runtime_1.jsx)(fi_1.FiXCircle, { className: "text-red-500", size: 25 }),
            selectedClasses: 'bg-red-100 border-red-500 text-red-700',
        },
    ];
    const filterItems = mode === 'legacy' ? legacyItems : items;
    const handleSelect = (itemValue) => {
        const newValue = value === itemValue ? '' : itemValue;
        onChange(newValue);
    };
    const renderIconButton = (item, isMobileView = true) => {
        const isSelected = value === item.value;
        const defaultIcon = item.icon || item.defaultIcon || (0, jsx_runtime_1.jsx)(tfi_1.TfiPlug, { size: 34 });
        const badgeIcon = item.badgeIcon;
        const selectedClasses = item.selectedClasses || 'bg-blue-100 border-blue-500 text-blue-700';
        const targetClass = `filter-${item.value}-${isMobileView ? 'mobile' : 'desktop'}`;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "relative", children: [item.description && ((0, jsx_runtime_1.jsx)(tooltip_1.Tooltip, { target: `.${targetClass}`, content: item.description, position: isMobileView ? 'left' : 'top', showDelay: isMobileView ? 300 : 200, hideDelay: isMobileView ? 0 : 100, mouseTrack: isMobileView, mouseTrackTop: 10 })), (0, jsx_runtime_1.jsx)(button_1.Button, { onClick: () => handleSelect(item.value), className: `
          ${targetClass}
          p-button-rounded p-button-lg shadow-lg p-3 transition hover:scale-105 animate-float
          min-h-[44px] min-w-[44px] flex items-center justify-center
          ${isSelected
                        ? `${selectedClasses} ring-2 ring-blue-400 scale-110`
                        : 'bg-white text-gray-800 border border-gray-300'}
        `, children: defaultIcon }), badgeIcon && ((0, jsx_runtime_1.jsx)("div", { className: "absolute -top-2 -right-2 bg-white rounded-full shadow-sm p-0.5 animate-float", children: badgeIcon }))] }));
    };
    if (isMobile && filterItems.length > 0) {
        // UX Decision: El filtro de estado es prioritario y debe estar siempre accesible
        // En mobile, lo posicionamos a la izquierda para evitar colisión con Settings (derecha)
        // Cuando está abierto, se mantiene a la izquierda con apilamiento vertical
        // Touch targets: mínimo 44px (los botones ya cumplen con p-button-lg ~48px)
        return ((0, jsx_runtime_1.jsxs)("div", { className: `fixed bottom-14 left-4 z-40 flex flex-col items-center transition-all duration-300 ease-in-out`, children: [open && ((0, jsx_runtime_1.jsx)("div", { className: "mb-3 flex flex-col items-center gap-3 animate-fade-in", children: filterItems.map((item, index) => {
                        const isSelected = value === item.value;
                        return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-center gap-1.5 animate-slide-up", style: {
                                animationDelay: `${index * 50}ms`,
                                animationFillMode: 'both',
                            }, children: [renderIconButton(item), (isSelected || !value) && item.description && ((0, jsx_runtime_1.jsx)("span", { className: "text-[11px] text-gray-500 text-center max-w-[90px] leading-tight whitespace-normal px-1", children: item.description }))] }, item.value));
                    }) })), (0, jsx_runtime_1.jsx)(button_1.Button, { icon: open ? (0, jsx_runtime_1.jsx)(fi_1.FiX, { size: 24 }) : (0, jsx_runtime_1.jsx)(fi_1.FiFilter, { size: 24 }), className: `p-button-rounded p-button-2xl bg-[var(--smart-blue)] text-white shadow-2xl transform transition-all duration-300
          hover:scale-110 active:scale-95 animate-float min-h-[44px] min-w-[44px] ${open ? 'rotate-90' : 'rotate-0'}`, onClick: () => setOpen((o) => !o), "aria-label": open ? 'Close filters' : 'Open filters' })] }));
    }
    // In desktop, show names by default, but show icons if showIconsInDesktop is true
    const allItemsHaveIcons = filterItems.length > 0 && filterItems.every((item) => item.icon);
    const itemTemplate = (option) => {
        if (option.icon) {
            const targetClass = `filter-${option.value}-desktop-btn`;
            return ((0, jsx_runtime_1.jsx)("span", { className: `${targetClass} flex items-center justify-center pointer-events-auto`, children: option.icon }));
        }
        return (0, jsx_runtime_1.jsx)("span", { children: option.name });
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "card flex justify-content-center gap-2 mr-2", children: [showIconsInDesktop && allItemsHaveIcons && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: filterItems
                    .filter((item) => item.description)
                    .map((item) => {
                    const targetClass = `filter-${item.value}-desktop-btn`;
                    return ((0, jsx_runtime_1.jsx)(tooltip_1.Tooltip, { target: `.${targetClass}`, content: item.description, position: "bottom", showDelay: 200, hideDelay: 100 }, `tooltip-${item.value}`));
                }) })), (0, jsx_runtime_1.jsx)(selectbutton_1.SelectButton, { value: value, onChange: (e) => onChange(e.value || ''), options: filterItems, ...(showIconsInDesktop && allItemsHaveIcons
                    ? { itemTemplate }
                    : { optionLabel: 'name' }), className: `flex justify-content-center text-xs border border-gray-200 rounded-3xl ${SelectStatusFilter_module_scss_1.default.customSelectButton}` })] }));
};
exports.SelectStatusFilter = SelectStatusFilter;
